import { Component, OnInit } from '@angular/core';
import {TaskService} from '../../services/task.service';
import G2 from '@antv/g2/build/g2';
import { DataSet } from '@antv/data-set/build/data-set';
import {UtilsModule} from '../../utils/utils.module';
@Component({
  selector: 'app-simple-statistics',
  templateUrl: './simple-statistics.component.html',
  styleUrls: ['./simple-statistics.component.css']
})
export class SimpleStatisticsComponent implements OnInit {
  boardIds: [string];
  isTaskStatisticsVisible: boolean;
  listOfLabel = [];
  listOfData = new Map<String, any>();
  labelData: [];
  isTaskVisible = false;
  chartData = [];
  groupData = [];
  boardName: string;
  checkOptions = [];
  checkedBoard = [];
  index: number;
  chart: any;
  total: number;
  constructor(
    private taskService: TaskService,
    private utilsModule: UtilsModule,
  ) { }

  ngOnInit(): void {
    this.getBoardList('');
  }

  getBoardList(boardName: string) {
    this.checkOptions = [];
    const param = {boardName: boardName};
    this.taskService.getUserBoardData().subscribe((res: any) => {
      console.log(res);
      const boards = res.boards;
      boards.forEach(val => {
        this.checkOptions.push({label: val.name, value: val.id, checked: true});
        this.checkedBoard.push(val.id);
      });
      this.getData();
    });
  }

  // 选中成员触发
  selectMember(item) {
  }
  // 配置弹窗
  openTaskStatisticsDialog() {
    this.isTaskStatisticsVisible = true;
  }
  // 获取统计列表数据
  getData() {
    this.taskService.getLabelGroupStatistics(this.checkedBoard).subscribe((res: any) => {
      if (res) {
        this.listOfLabel = Object.keys(res);
        const labels = [];
        this.listOfData = res;
        this.chartData = [];
        this.listOfLabel.forEach(key => {
          // tslint:disable-next-line:no-unused-expression
          const data = {type: key, count: this.listOfData[key]?.length, color: this.getAvatarColor()};
          this.chartData.push(data);
        });
        this.changeLabel(this.listOfLabel[0]);
        this.handelChartData();
        // this.chart.changeData(this.chartData);
      }
    });
  }
  // 处理图表数据
  handelChartData() {
    const sum = 500;
    const ds = new DataSet();
    const dv = ds.createView().source(this.chartData);
    dv.transform({
      type: 'map',
      callback(row) {
        row.value = (sum * row.count).toFixed(0);
        return row;
      }
    });
    if (!this.chart) {
      this.chart = new G2.Chart({
        container: 'container',
        forceFit: true,
        height: 240,
        padding: 'auto'
      });
    }
    this.chart.source(dv);
    this.chart.tooltip({
      showTitle: false,
      itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>'
    });
    // this.chart.legend({
    //   position: 'right-center',
    //   offsetX: -100,
    //   formatter: (text, item) => {
    //     return text;
    //   }
    // });
    this.chart.legend({
      useHtml: true,
      position: 'right-center',
      reactive: true,
      containerTpl: '<div class="g2-legend-wrapper">' + '<ul class="g2-legend-list"></ul>' + '</div>',
      itemTpl: function itemTpl(value, color, checked, index) {
        const obj = dv.rows[index];
        let _t = 0;
        // const percent = (obj.count / dv.rows[length - 1].total * 100).toFixed(2) + '%';
        if (dv.rows) {
          dv.rows.forEach(item => {
            _t = item.count + _t;
          });
        }
        const percent = ((obj.count / _t) * 100).toFixed(2) + '%';
        checked = checked ? 'checked' : 'unChecked';
        return '<li class="g2-legend-list-item item-' + index + ' ' + checked + '" data-value="' + value + '" data-color=' + color + ' >' + '<div style="width:100px;"><i class="g2-legend-marker" style="width:10px;height:10px;display:inline-block;margin-right:10px;background-color:' + color + ';"></i>' + '<span class="g2-legend-text" style="color: #666">' + value + '</span></div>' + '<div style="text-align: right">' + percent + '</div>' + '<div style="text-align: right;color: #666;width:30px;margin-left:15px">' + obj.count + '</div>' + '</li>';
      },
      offset: [15, 0],
      'g2-legend': {
        position: 'absolute'
      },
      'g2-legend-list': {
        listStyleType: 'none',
        margin: 0,
        padding: 0
      },
      'g2-legend-list-item': {
        cursor: 'pointer',
        fontSize: '14px'
      }
    });
    this.chart.coord('theta', {
      radius: 0.75,
      innerRadius: 0.8
    });
    this.chart.intervalStack().position('count').color('type', [ '#F04864', '#FACC14', '#2FC25B', '#13C2C2', '#1890FF', '#8543E0' ]);
    this.chart.guide().text({
      position: ['50%', '50%'],
      content: '统计类型',
      style: {
        lineHeight: '240px',
        fontSize: '24',
        fill: '#262626',
        textAlign: 'center'
      }
    });
    this.chart.render();
  }
  getAvatarColor() {
    return this.utilsModule.getRandomColor();
  }
  openTaskDialog(group: any) {
    this.groupData = [];
    const params  = {groupId: group.groupId};
    this.taskService.getGroupRowsValue(params).subscribe((res: any) => {
      res.forEach(value => {
        if (value.timeInterval) {
          const date = JSON.parse(value.timeInterval)?.date;
          if (date && date.length > 0) {
            value['startDate'] = this.utilsModule.formatDateByGeneral(new Date(date[0]));
            value['endDate'] = this.utilsModule.formatDateByGeneral(new Date(date[1]));
          }
        }
        value['timeText'] = UtilsModule.calculateTime(value.updateAt);
      });
      this.groupData = res;
    });

    this.isTaskVisible = true;
  }
  handleTaskOk() {}
  handleTaskCancel() {
    this.isTaskVisible = false;
  }

  changeLabel(label: string) {
    this.labelData = this.listOfData[label];
    console.log(this.labelData);
  }


  boardChange(val) {
    if (val === false) {
      console.log(val);
      this.checkedBoard = [];
      if (this.checkOptions && this.checkOptions.length > 0) {
        this.checkOptions.filter(value => value.checked === true).forEach(value => {
          this.checkedBoard.push(value.value);
        });
      }
      this.getData();
      console.log(this.checkedBoard);
    }
  }
}
